function FiltersToFormData(filters, target = {}) {
  Object.entries(filters).forEach(([key, val]) => {
    let result = null;

    // Handle arrays
    if (Array.isArray(val)) {
      result = val.map((item) => item?.value ?? item);
    }

    // Handle objects
    else if (val && typeof val === 'object') {
      if ('value' in val) {
        result = val.value;
      } else if (val instanceof Date) {
        result = val.toISOString();
      } else if (val.from || val.to) {
        if (val.from instanceof Date) {
          target['from_date'] = val.from.toISOString();
          console.log(`Added filter: from_date =`, target['from_date']);
        }
        if (val.to instanceof Date) {
          target['to_date'] = val.to.toISOString();
          console.log(`Added filter: to_date =`, target['to_date']);
        }
        return;
      }
    }

    // Handle primitives
    else if (val !== null && val !== undefined) {
      result = val;
    }

    // Assign result if valid
    if (result !== null && result !== '' && result !== undefined) {
      target[key] = result;
      console.log(`Added filter: ${key} =`, result);
    } else {
      console.log(`Skipping empty filter: ${key}`);
    }
  });

  return target;
}
export { FiltersToFormData };